import * as R from 'ramda'

import { SET_ENTITIES } from 'actions'

const initialState = {
  allIds: [],
  entities: {},
}

const customerSearchFilterResult = (state = initialState, action) => {
  const { allIds, entities } = state
  switch (action.type) {
    case SET_ENTITIES:
      return {
        allIds: R.union(allIds, action.allIds.customers),
        entities: R.merge(entities, action.entities.customers),
      }

    default:
      return state
  }
}

export default customerSearchFilterResult

export const getCustomerEntities = (state) => state.entities

export const getCustomer = (state, customerId) => state.entities[customerId]



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/reducers/data/customer.js